<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header pageTitle="Manage Hierarchy" class="card-container"></Header>


      <el-row :gutter="40">
        <el-col :span="8">
          <base-button class="align-l" @click="createNew"> Add new</base-button>

          <base-input placeholder="Filter keyword" v-model="filterText">
          </base-input>

          <div class="div-scroll">
            <el-tree :key="componentKey" class="filter-tree" :data="jointStaffOrganizations" :props="defaultProps"
              :render-content="renderTreeItem" :expand-on-click-node="false" :filter-node-method="filterNode"
              default-expand-all node-key="id" ref="menutree">
            </el-tree>
          </div>
        </el-col>

        <el-col :span="16">
          <form ref="organizationForm" @submit.prevent="save">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <legend>{{ this.organization.id ? 'Edit' : 'Add' }} Information </legend>

                <fieldset>
                  <div class="row">
                    <div class="col-md-12">
                      <label>Parent</label>
                        <treeselect aria-label="Select organization from the dropdown list"
                          v-model="organization.parentId" name="parent" v-validate="'required'"
                          :class="errors.has('parent') ? 'has-danger' : ''"
                          :options="jointStaffOrganizations" />
                      
                          <span v-show="errors.has('parent')" class="error"> {{ errors.first("parent") }}
                          </span>
                    </div>
                  </div>
                </fieldset>


                <fieldset>
                  <div class="row">
                    <div class="col-md-12">
                      <base-input type="text" label="Name" placeholder="Name" v-model="organization.name" v-validate="'required'"
                        :error="getError('name')">
                      </base-input>
                    </div>

                    <div class="col-md-12">
                      <base-input type="text" label="Abbreviation" placeholder="Abbreviation"
                        v-model="organization.abbreviation"  v-validate="'required'" :error="getError('abbreviation')"
                        addon-left-icon="tim-icons icon-single-02">
                      </base-input>
                    </div>
                  </div>
                </fieldset>

                <fieldset>
                  <div class="row">
                    <div class="col-md-12">
                      <base-input label="Country " :error="getError('country')">
                        <v-select :disabled="!isNew" class="style-chooser" v-model="organization.countryId"
                          name="country" :reduce="(country) => country.countryId" label="name"
                          :options="isNew ? allCountries.filter((e) => e.name.toLowerCase() === 'united states') : allCountries"
                          v-validate="'required'" placeholder="Select one">
                        </v-select>
                      </base-input>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <base-input label="Service / Parent Organization" :error="getError('service')">
                        <v-select class="style-chooser" label="name" v-model="organization.serviceId" name="service"
                        :options="services"  :reduce="service => service.serviceId"
                        v-validate="'required'" placeholder="Select">
                        </v-select>
                      </base-input>
                    </div>
                  </div>
                </fieldset>

                <fieldset>
                  <div class="row">
                    <div class="col-md-12">
                      <base-input label="Enabled"> <el-checkbox v-model="selectedOption"></el-checkbox> </base-input>
                    </div>
                  </div>
                </fieldset>

                <fieldset>
                  <div class="edit_information_grid">
                    <div>
                      <base-input type="text" label="Created" disabled placeholder="Created"
                        v-model="organization.createDate" addon-left-icon="tim-icons icon-calendar-60">
                      </base-input>
                    </div>

                    <div>
                      <base-input type="text" label="Updated" placeholder="Updated" disabled
                        v-model="organization.updateDate" addon-left-icon="tim-icons icon-calendar-60">
                      </base-input>
                    </div>
                  </div>
                </fieldset>

                <base-button native-type="submit" size="md" :class="'btn_extra_small btn-primary'">
                  {{ saveUpdateButton }}
                </base-button>

              </div>
            </div>
          </form>
        </el-col>
      </el-row>
    </div>
  </center>
</template>

<script>
import Header from "@/components/App/Header.vue";
import Treeselect from "@riophae/vue-treeselect";
import { Row, Col, Tree, Checkbox } from "element-ui"
import { mapGetters, mapActions } from "vuex";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import BaseButton from '../../components/BaseButton.vue';

export default {
  name: "SuperUserHierarchy",
  components: {
    Header,
    Treeselect,
    BaseButton,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tree.name]: Tree,
    [Checkbox.name]: Checkbox

  },
  data() {
    return {
      filterText: '',
      componentKey: 0,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      selectedOption: true,
      isNew: true,
      enableDisable: [
        'true',
        'false'
      ],
    };
  },
  computed: {
    ...mapGetters({
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      organization: 'organization/organization',
      allCountries: "countries/allCountries",
      services: "services/services"
    }),
    saveUpdateButton() {
      return this.organization.id ? 'Update' : 'Save'
    }
  },

  watch: {
    filterText(val) {
      this.$refs.menutree.filter(val);
    }
  },
  async created() {
    await this.getServices();
    await this.getJointStaffOrganizations(true);
    await this.getAllCountries();
    this.organization.isActive = true
  },
  methods: {
    ...mapActions({
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getOrganization: 'organization/getOrganization',
      saveOrganization: 'organization/saveOrganization',
      getAllCountries: "countries/getAllCountries",
      getServices: "services/getServices",
    }),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    renderTreeItem(h, { node, data, store }) {
      if (data.isActive) return (
        <span class="tree-item">
          <base-button type="link" class="d-flex justify-content-start"
            style="font-size: 12px; padding-left: 0; border: none !important; outline: none !important; outline-offset: 0;"
            on-click={async () => { this.$loaderApp.addRequest(); await this.getOrganization(data.id); this.selectedOption = this.organization.isActive; this.isNew = false; this.$loaderApp.completeRequest(); }}>{node.label}</base-button>
        </span>
      )

      else return (
        <span class="tree-item">
          <base-button type="link" class="d-flex justify-content-start"
            style="font-size: 12px; padding-left: 0; border: none !important; outline: none !important; outline-offset: 0; color: red"
            on-click={async () => { this.$loaderApp.addRequest(); await this.getOrganization(data.id); this.selectedOption = this.organization.isActive; this.isNew = false; this.$loaderApp.completeRequest(); }}>{node.label}</base-button>
        </span>
      )
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    async createNew() {
      this.isNew = true
      await this.getOrganization(0)
       this.$validator.reset();
      this.organization.isActive = true
    },
    async save() {
      this.$loaderApp.addRequest();
      
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          const ctx = this;

          await ctx.saveOrganization(ctx.selectedOption);
          await ctx.getJointStaffOrganizations(true);
          ctx.forceRerender();
          
          if (ctx.organization.id) {
            await ctx.getOrganization(ctx.organization.id)
            ctx.selectedOption = ctx.organization.isActive
          } 
          
          else {
            await ctx.getOrganization(0)
          }

          ctx.$loaderApp.completeRequest();
        } 
        
        else {
          this.$loaderApp.completeRequest();
          this.$toast.error("Please fill the required fields.");
        }
      });
    },
  },
};
</script>

<style scoped>
.div-scroll {
  overflow-y: scroll;
  overflow-x: scroll;
  height: 700px;
  width: 100%;
}

.tree-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.align-l {
  margin-right: 300px;
  margin-bottom: 20px
}
</style>
